import { render, staticRenderFns } from "./LandingPageSettingWidget.vue?vue&type=template&id=7b67653c&scoped=true&"
import script from "./LandingPageSettingWidget.vue?vue&type=script&lang=js&"
export * from "./LandingPageSettingWidget.vue?vue&type=script&lang=js&"
import style1 from "./LandingPageSettingWidget.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67653c",
  null
  
)

export default component.exports